import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import Spinner from "../spinner/Spinner";
import BlockOne from "./BlockOne";

const MonthStat = (props) => {
  // console.log('render monthStat')
  // console.log("MonthStatProps", props);
  const { data, saveFullApartSquare } = props;
  // const [statDat, setStatDat] = useState([]);

  // useEffect(() => {
  //   setStatDat(data);
  // }, [data]);

  const CustomBox = styled(Paper)({
      minHeight: "250px",
      borderRadius: "12px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
      padding: "35px 0 35px 60px",
      width: "100%",
      overflow: "hidden",
  });
  return (
    <>
      {/* {console.log("data", data)} */}
      {!data.length ? <Spinner /> : <BlockOne statDat={data} saveFullApartSquare={saveFullApartSquare} CustomBox={CustomBox} />}
    </>
  );
};

export default MonthStat;
